import * as React from "react";

function SvgDashboardZone(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 26 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.64 1.472c-.507-.994-1.177-1.604-2.265-.71-.87.716-1.723.829-2.817.415-1.22-.46-2.598-.385-3.593.504-.783.704-1.469.607-2.188.239-1.096-.56-2.139-1.09-3.355-.343-.36.221-.611.001-.898-.234C6.807-.075 4.87-.393 3.548.496 2.413 1.26 1.417 4.433 2.031 5.84c.41.942.141 1.868-.313 2.396C.233 9.958-.385 11.798.256 14.026c-.788 1.855.378 1.89 1.661 1.725 1.7-.216 2.713.67 3.454 2.036 1.457 2.69 1.462 2.73 4.284 2.009.463-.118.894-.096 1.335-.145.98-.106 1.762-.621 1.866-1.52.16-1.377 1.075-2.154 1.966-2.91.71-.602 1.69-1.197 2.472.012.554.86.89.379 1.235-.133 1.027-1.529 1.475-3.347 2.675-4.826 1.259-1.55 1.126-4.025 3.341-5.052.508-.235.62-1.348.195-1.707-.691-.584-.753-1.358-1.1-2.043z"
        fill="#fff"
        fillOpacity={0.8}
      />
    </svg>
  );
}

export default SvgDashboardZone;
